import { api as discussionApi } from './auto-generated/discussion'
import { api as eventApi } from './auto-generated/event'
import { RootState } from '@app/store'
import { API_BASE_URL } from '@config'
import { createSocket } from './ws'
import { refreshTokenIfExpired } from '@features/auth/utils/refresh-token-if-expired'

discussionApi.enhanceEndpoints({
  endpoints: {
    discussionStartDiscussion: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        dispatch(
          eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
            draftEvent.event_type = 'DISCUSSION'
          }),
        )
        dispatch(
          eventApi.util.updateQueryData('eventGetCurrentEvent', undefined, (draftEvent) => {
            draftEvent.event_type = 'DISCUSSION'
          }),
        )
        try {
          await queryFulfilled
        } catch {}
      },
    },
    discussionGetCurrentDiscussionTopic: {
      async onCacheEntryAdded(arg, { cacheDataLoaded, cacheEntryRemoved, getState, dispatch }) {
        const { tokens } = (getState() as RootState).auth
        const { eventId } = arg
        if (tokens && eventId) {
          let ws
          // create a websocket connection when the cache subscription starts
          try {
            // wait for the initial query to resolve before proceeding
            await cacheDataLoaded
            const listener = (event: MessageEvent) => {
              const data = JSON.parse(event.data)
              // if (!isMessage(data) || data.channel !== arg) return   TODO add isMessage validator schema
              console.log(data)
              switch (data.event_type) {
                case 'SET_DISCUSSION_TOPIC':
                  dispatch(
                    discussionApi.util.updateQueryData(
                      'discussionGetCurrentDiscussionTopic',
                      { eventId: eventId },
                      (draftTopic) => {
                        draftTopic = data.event_message.discussion_topic
                        return draftTopic
                        // draftTopic.phrase =
                        //   data.event_message.discussion_topic.phrase
                      },
                    ),
                  )
                  break
                default:
                  break
              }
            }
            ws = await createSocket(eventId, listener)
            // when data is received from the socket connection to the server,
            // if it is a message and for the appropriate channel,
            // update our query result with the received message
          } catch {
            // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
            // in which case `cacheDataLoaded` will throw
          }
          // cacheEntryRemoved will resolve when the cache subscription is no longer active
          await cacheEntryRemoved
          // perform cleanup steps once the `cacheEntryRemoved` promise resolves
          if (ws) {
            ws.close()
          }
        }
      },
    },
  },
})

export { discussionApi }
